import { CLEAR_TOAST, TOAST_SHOWN } from './types'

export const clearToast = ({ id }) => ({
  type: CLEAR_TOAST,
  payload: id,
})

export const toastShown = ({ id }) => ({
  type: TOAST_SHOWN,
  payload: id,
})
